export const CorporateLayout = {
    data: () => ({
        user: window.user,
        wallets: [],
        profileFile: null,
    }),
    methods: {
        async uploadProfile($event) {
            this.profileFile = $event.target.files[0];
            const formData = new FormData();

            formData.append('corporate_logo', this.profileFile);

            const response = await axios.post('/business/profile', formData);

            this.user.corporate = response.data.body.model;
        },
        initializeTooltips() {
            this.$nextTick(() => {
                $('[data-toggle="tooltip"]').tooltip();
            });
        },
    },
    mounted() {
        this.initializeTooltips();
    },
    updated() {
        this.initializeTooltips();
    },
    metaInfo: {
        title: "Corporate Dashboard"
    }
}
